module.exports = __webpack_public_path__ + "whitetwocandles.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitetwocandles.png
// module id = 907
// module chunks = 0